import './language-changer.scss';

import { useState } from 'react';

import { Button, OutsideClickHandler } from '@/components/Shared/ui';
import { Languages, SUPPORTED_LANGUAGES } from '@/constants';
import useAppNavigate from '@/hooks/useAppNavigation';
import { gaEvent } from '@/lib/google-analytics';

interface IProps {
  className?: string;
}

const LanguageChanger: React.FC<IProps> = ({ className = '' }) => {
  const { changeLanguage, currentLang } = useAppNavigate();

  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleSelect = (language: Languages) => {
    changeLanguage(language);
    setIsOpen(false);
    gaEvent('change_language', {
      language_old: currentLang,
      language_new: language
    });
  };

  return (
    <OutsideClickHandler onOutsideClick={handleClose}>
      <div className={`language-changer ${className}`}>
        <Button
          className="language-changer__button"
          onClick={handleToggle}
          type="button"
          size="small"
          isSquare
        >
          {currentLang}
        </Button>
        {isOpen && (
          <div className="language-changer__popup">
            <ul className="language-changer__list">
              {SUPPORTED_LANGUAGES.map((option) => (
                <li
                  onClick={() => handleSelect(option)}
                  className={`language-changer__item ${
                    currentLang === option
                      ? 'language-changer__item--selected'
                      : ''
                  }`}
                  key={option}
                >
                  {option}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </OutsideClickHandler>
  );
};

export default LanguageChanger;
